import React from 'react'
import { Route, Routes } from 'react-router-dom';

import AllSEO from '../seo/AllSEO';

const SEORoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/all-seo" element={<AllSEO />} />
            </Routes>
        </>
    )
}

export default SEORoutes;